import { useMemo } from 'react';
import { Row } from '@harmony/enablers/components/data-grid/data-grid';
import { TColumnData } from '../../shared-components/table-filters-panel';
import { useMEMTranslation } from '../../utils/text-utils';
import { EUserNotificationType, TUserNotification } from '../../ducks/api-ducks/user-notifications-duck/types-user-notifications';
import { useMonthDayYearWithDefaultTimeZone } from '../../utils/date-utils';
import { getRichMessageForNotification } from '../../utils/notification-utils';

export const useNotificationsColumns = (): TColumnData[] => {
  const { t } = useMEMTranslation();
  return useMemo(
    () => [
      {
        field: 'notification',
        content: t('notificationsPanelColumnNotification'),
        display: {
          width: '60%',
        },
      },
      {
        field: 'notificationStatus',
        content: t('notificationsPanelColumnStatus'),
        sortable: true,
      },
      {
        field: 'notificationPostedDate',
        content: t('notificationsPanelColumnDate'),
        sortable: true,
      },
    ],
    [t]
  );
};

export const useNotificationsRows = (notifications: TUserNotification[]): Row<TUserNotification>[] => {
  const parseDate = useMonthDayYearWithDefaultTimeZone();
  const { t } = useMEMTranslation();
  const mediaLinkText = t('splashScreenOpenMedia');
  return useMemo(
    () =>
      notifications.map((notification) => {
        let notificationCell: string;
        const customData = { ...notification };
        switch (notification.notificationType) {
          case EUserNotificationType.ActionCenter:
            notificationCell = notification.message || '';
            break;
          case EUserNotificationType.SplashScreen:
            notificationCell = getRichMessageForNotification(notification, mediaLinkText) || '';
            customData.richMessage = notificationCell;
            break;
          default:
            notificationCell = notification.richMessage || '';
            break;
        }
        return {
          id: notification.notificationReferenceId || '',
          customData,
          cells: {
            notification: notificationCell,
            notificationStatus: notification.notificationStatus || '',
            notificationPostedDate: parseDate(notification.notificationStartDate || ''),
          },
        };
      }),
    [notifications, parseDate, mediaLinkText]
  );
};
